import {initSlider} from "../helpers/service.slider";
import {ajax, event, selectDoc} from "../utils/utils";
import {inputEmpty, serialize, showErrorPDPForm} from "../helpers/service.validator";
import {addCartItemData, removeCartItem} from "../helpers/service.cart";
import {notify} from "../helpers/service.notification";
import {MiniCart} from "./component.minicart";

const props = {}

const initializer = () => {
    initSlider('.services-slider', {
        type: 'carousel',
        focusAt: 'center',
        perView: 1,
        rewindDuration: 0,
        peek: {
            before: 0,
            after: 0
        }
    });
}

const initAddToTah = (container, atcCta, atcProps) => {
    if (atcCta) {
        event(atcCta, 'click', function (e) {
            e.preventDefault()
            if (!props.addingtoCart) {
                let form = selectDoc(`${container} form.shopify-product-form`),
                    formData = serialize(form);

                if (props.currentSize) {
                    formData.properties.band_size = props.currentSize.getAttribute('data-title')
                }

                //Validate required inputs
                let validateRing = (inputEmpty(formData.properties['band_size']) && atcProps.isRing);
                if (inputEmpty(formData.handle) ||
                    inputEmpty(formData.id) ||
                    inputEmpty(formData.properties['diamond_code']) ||
                    inputEmpty(formData.properties['metal_code']) ||
                    validateRing) {

                    let sizeTab = selectDoc('[data-target="size-body"]')
                    if (sizeTab) {
                        showErrorPDPForm(atcCta, 'Please select a band size')
                        sizeTab.click()
                    }
                    if (atcProps.productForm) {
                        atcProps.productForm.scrollIntoView();
                    }

                } else {
                    MiniCart.toggleOverlay()
                    props.addingtoCart = true;
                    atcCta.classList.add('atc--inactive')
                    formData.properties['isTah'] = true;
                    formData.properties['handle'] = formData.handle;

                    new Promise(resolve => {
                        ajax('GET', "/cart.js")
                            .then(function (response) {
                                resolve(response);
                            });
                    }).then(function (response) {
                        response = JSON.parse(response);
                        if (response.status === 200) {
                            const cartData = JSON.parse(response.response);

                            ajax('GET', "/products/" + formData.handle + ".js")
                                .then(function (response) {
                                    let productData = JSON.parse(response);
                                    if (productData.status !== undefined) {
                                        if (productData.status === 200) {
                                            let product = JSON.parse(productData.response);

                                            /**
                                             * Cart is empty
                                             */
                                            if (cartData.items.length < 1) {
                                                let b3 = product.variants.find(variant => (variant.title.replaceAll(' ', '')) === 'Bundle3')
                                                if (b3) {
                                                    formData.id = b3.id
                                                    addCartItemData(JSON.stringify(formData), {
                                                        'name': product.title,
                                                        'id': formData.id,
                                                        'price': '$99',
                                                        'quantity': 1
                                                    }).then(function (response) {
                                                        if (product) {
                                                            let closeQuickadd = selectDoc(`#qv-product-modal-${product.id} button.close-modal`);
                                                            if (closeQuickadd) {
                                                                closeQuickadd.click()
                                                            }
                                                        }
                                                        MiniCart.redirect()
                                                        props.addingtoCart = false;
                                                        atcCta.classList.remove('atc--inactive')
                                                    })
                                                }
                                            } else {
                                                let tahCount = 0,
                                                    line = 1,
                                                    tahHandles = [];
                                                cartData.items.map(item => {
                                                    if (item.properties) {
                                                        if (item.properties.isTah) {
                                                            tahCount++
                                                            tahHandles.push({
                                                                properties: item.properties,
                                                                id: item.id,
                                                                line: line
                                                            })
                                                        }
                                                    }
                                                    line++;
                                                })

                                                if (tahCount >= 3) {
                                                    atcCta.classList.remove('atc--inactive')
                                                    props.addingtoCart = false;
                                                    notify('Oops!',
                                                        `You already have <strong>3</strong> pieces in your kit. \n Please remove one from your kit before adding.`,
                                                        'Review My Kit',
                                                        '/cart')
                                                } else {
                                                    switch (tahCount) {
                                                        case 1:
                                                            tahHandles[0].bundle = 'Bundle2';
                                                            break;
                                                        case 2:
                                                            tahHandles[0].bundle = 'Bundle1';
                                                            tahHandles[1].bundle = 'Bundle1';
                                                            break;
                                                        default:
                                                            break
                                                    }

                                                    processBundles(tahCount, product, formData, tahHandles, atcCta);
                                                }
                                            }
                                        }
                                    }
                                })
                        } else {
                            console.log('Error fetching cart products data.');
                        }
                    })
                }
            }
        })
    }
}

const processBundles = async (tahCount, product, formData, tahHandles, atc) => {
    function addCurrentProduct(prod, atcCta) {
        if (prod) {
            let b = prod.variants.find(variant => (variant.title.replaceAll(' ', '')) === (tahCount < 1 ? 'Bundle3' : 'Bundle1'))
            if (b) {
                formData.id = b.id
                addCartItemData(JSON.stringify(formData), {
                    'name': product.title,
                    'id': formData.id,
                    'price': '$99',
                    'quantity': 1
                }).then(function (response) {
                    if (product) {
                        let closeQuickadd = selectDoc(`#qv-product-modal-${product.id} button.close-modal`);
                        if (closeQuickadd) {
                            closeQuickadd.click()
                        }
                    }
                    MiniCart.redirect()
                    props.addingtoCart = false;
                    if (atcCta) {
                        atcCta.classList.remove('atc--inactive')
                    }
                })
            }
        } else {
            if (product) {
                let closeQuickadd = selectDoc(`#qv-product-modal-${product.id} button.close-modal`);
                if (closeQuickadd) {
                    closeQuickadd.click()
                }
            }
            MiniCart.redirect()
            props.addingtoCart = false;
            if (atcCta) {
                atcCta.classList.remove('atc--inactive')
            }
        }
    }

    function addExtraProduct(tahHandle, callback, args) {
        //Re-add item to cart
        ajax('GET', "/products/" + tahHandle.properties.handle + ".js")
            .then(function (response) {
                let productData = JSON.parse(response);
                if (productData.status !== undefined) {
                    if (productData.status === 200) {
                        let subProduct = JSON.parse(productData.response),
                            bundle = subProduct.variants.find(variant => (variant.title.replaceAll(' ', '')) === tahHandle.bundle)
                        if (bundle) {
                            let formData1 = {
                                properties: tahHandle.properties,
                                id: bundle.id
                            }
                            addCartItemData(JSON.stringify(formData1), {
                                'name': subProduct.title,
                                'id': formData1.id,
                                'price': '$99',
                                'quantity': 1
                            }).then(function (response) {
                                callback.apply(this, args)
                            })
                        }
                    }
                }
            })
    }

    if (tahCount < 1) {
        addCurrentProduct(product, atc)
    } else {
        if (tahCount === 1) {
            removeCartItem((tahHandles[0].line)).then(function (response) {
                addExtraProduct(tahHandles[0], addCurrentProduct, [product, atc])
            })
        } else {
            if (tahCount === 2) {
                removeCartItem((tahHandles[0].line)).then(function (response) {
                    removeCartItem((tahHandles[1].line - 1)).then(function (response) {
                        addExtraProduct(tahHandles[0], addExtraProduct, [tahHandles[1], addCurrentProduct, [product, atc]])
                    })
                })
            }
        }
    }
}

export const TAH = {
    init: () => initializer(),
    processBundles: (tahCount, product, formData, tahHandles, atc) => processBundles(tahCount, product, formData, tahHandles, atc),
    initAddToTah: (container, atcCta, atcProps) => initAddToTah(container, atcCta, atcProps)
}
